import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { BenefitsEnrollmentCancellationReasonEnum } from "@oysterhr/schema"
import { useAccountAspect } from "@oysterhr/identity"

export function useFinishReasonOptions(excludeMoved = true) {
  const { t } = useTranslation("benefits/CancellationReasonForm")
  const { isCompany } = useAccountAspect()
  return useMemo(() => {
    const reasonsToExclude = new Set([
      excludeMoved ? BenefitsEnrollmentCancellationReasonEnum.Moved : null,
    ])
    if (isCompany) {
      reasonsToExclude.add(BenefitsEnrollmentCancellationReasonEnum.CustomerRequest)
      reasonsToExclude.add(BenefitsEnrollmentCancellationReasonEnum.Reconciliation)
    }
    return Object.values(BenefitsEnrollmentCancellationReasonEnum)
      .filter(cancelReason => !reasonsToExclude.has(cancelReason))
      .map(element => {
        return {
          label: t(`cancellationReasons.${element}`),
          value: element,
        }
      })
  }, [t, excludeMoved, isCompany])
}
